import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { BillingInfoRequest } from '@ctct/domain-layer';
import { billingInfoRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';
import { QueryKeys } from '../queries/constants';

export const useUpdateBillingInfo = () => {
  const client = useQueryClient();

  const mutation = useMutation({
    mutationFn: billingInfoRepo.updateBillingInfo.bind(billingInfoRepo),
    onSuccess(data) {
      client.setQueryData([QueryKeys.BILLING_INFO], data);
    },
  });

  return useMutationMemoized(mutation);
};

export type UpdateBillingInfoMutation = ReturnType<typeof useUpdateBillingInfo>;

export type UpdateBillingInfoPayload = BillingInfoRequest;
